// extracted by mini-css-extract-plugin
export default {"container":"AppSwitch-module_container__CHfZY","image":"AppSwitch-module_image___55A6"};